import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { convertDate } from '../../utils/Utils'

export const ReadTable = ({ data = [], headers = [], headerAlignment = 'center', dataAlignment = 'center' }) => {
    const renderValue = (row, key, type = '') => {
        let rowValue = row?.[key] || ''
        if (key.includes('dt', 'date') || type === ColumnType.date) {
            return convertDate(row?.[key])
        }
        return rowValue
    }

    return (
        <TableContainer component={Paper} id='entitlement_id'>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {headers?.map((ele, index) => <TableCell key={index + ele?.key} align={headerAlignment} sx={{ fontWeight: 'bold' }}>
                            <>{ele?.value}</>
                        </TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((row, index) => (
                        <TableRow key={index}>
                            {headers?.map(({ key, type }, idx) =>
                                <TableCell
                                    key={index + idx + Math.random()}
                                    align={dataAlignment}>
                                    <>{renderValue(row, key, type)}</>
                                </TableCell>)}
                        </TableRow>
                    ))
                    }
                </TableBody>
            </Table>
            {!data?.length
                ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
                    No Records to display
                </div>
                : <div />
            }
        </TableContainer>
    )
}

export const ColumnType = {
    date: 'date',
    chip: 'chip',
}